import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { uniqueId } from 'lodash';
import Swal from 'sweetalert2';
import Select, { OptionProps, Options, OptionsOrGroups } from 'react-select';
import mapeamentoBancarioService from '../../services/mapeamentoBancarioService';
import planoContasService from '../../services/planoContasService';

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';


const ModalMapeamento = ({ esteiraID, empresaID, show, toggleModal }: { esteiraID: number, empresaID: number, show: boolean, toggleModal: Function }) => {
    const { t } = useTranslation();
    const [tipos] = useState([
        {
            key: 'adiantamento clientes',
            value: 'ADIANTAMENTO DE CLIENTES'
        },
        {
            key: 'adiantamento fornecedor',
            value: 'ADIANTAMENTO DE FORNECEDORES'
        },
        {
            key: 'TARIFA',
            value: 'TARIFA'
        },
        {
            key: 'JUROS/COMISSÕES',
            value: 'JUROS/COMISSÕES'
        },
        {
            key: 'COMISSÃO DE PERMANÊNCIA',
            value: 'COMISSÃO DE PERMANÊNCIA'
        },
        {
            key: 'JUROS',
            value: 'JUROS'
        },
        {
            key: 'DESCONTOS',
            value: 'DESCONTOS'
        },
        {
            key: 'VALOR DO ABATIMENTO',
            value: 'VALOR DO ABATIMENTO'
        },
        {
            key: 'IOF',
            value: 'IOF'
        },
        {
            key: 'REAJUSTE',
            value: 'REAJUSTE'
        },
        {
            key: 'VALOR CORRIGIDO',
            value: 'VALOR CORRIGIDO'
        },
        {
            key: 'TARIFA DE CONTRATAÇÃO',
            value: 'TARIFA DE CONTRATAÇÃO'
        },
        {
            key: 'PROVISÃO RETIDA',
            value: 'PROVISÃO RETIDA'
        },
        {
            key: 'RESGATE',
            value: 'RESGATE',
        },
        {
            key: 'RENDIMENTO',
            value: 'RENDIMENTO',
        },
        {
            key: 'APLICAÇÃO',
            value: 'APLICAÇÃO'
        }
    ])

    const [conta, setConta] = useState<any>(null)
    const [tipoSelecionado, setTipoSelecionado] = useState<any>(null)
    const [mapeamentos, setMapeamentos] = useState<any[]>([])
    const [carregando, setCarregando] = useState(false)
    const [planoContas, setPlanoContas] = useState<any[]>([])

    useEffect(() => {
        setMapeamentos([])
        if (esteiraID > 0 && empresaID > 0) {
            const load = async () => {
                const result = await mapeamentoBancarioService.listar(empresaID)
                setMapeamentos(result);

                const resultPlanoConta = await planoContasService.listar(esteiraID);
                setPlanoContas(resultPlanoConta);
            }

            load()
        }
    }, [empresaID, esteiraID])

    const onRemove = useCallback(async (id: any) => {
        if (!carregando) {
            setCarregando(true)
            await mapeamentoBancarioService.remover(id)
            setMapeamentos((old) => {
                return old.filter(f => f.id !== id)
            });
            setCarregando(false)
        }
    }, [carregando])

    const onSubmit = useCallback(async () => {
        if (!carregando) {
            setCarregando(true);
            if (conta && tipoSelecionado && empresaID > 0 && esteiraID > 0) {
                if (mapeamentos.find(f => f.descricao === tipoSelecionado.value || f.conta === conta.value)) {
                    Swal.fire({
                        text: ' O mapeamento já existe na empresa',
                        timer: 4000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                } else {
                    const result = await mapeamentoBancarioService.cadastrar(empresaID, tipoSelecionado.value, conta.value);
                    setMapeamentos((old) => {
                        const cp = [...old]
                        cp.push(result)
                        return cp
                    })


                    Swal.fire({
                        text: 'Mapeamento criado com sucesso',
                        timer: 4000,
                        icon: 'success',
                        showConfirmButton: false
                    })


                    setConta('')
                    setTipoSelecionado('')
                }
            } else {
                Swal.fire({
                    text: ' Por favor preencha todos os campos para inserir o mapeamento',
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
            setCarregando(false)
        }


    }, [conta, tipoSelecionado, empresaID, esteiraID, carregando, mapeamentos]);

    return (
        <Modal fullscreen centered={true} show={show} scrollable onHide={() => toggleModal()}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header" style={{ justifyContent: 'center' }}>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={() => toggleModal()} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t("Mapeamento de contas")}</h5>
                </div>
                <div className="modal-body" id="scrollableDiv">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <Select placeholder={t("Selecione um tipo")} isDisabled={carregando} value={tipoSelecionado} onChange={(e) => setTipoSelecionado(e || null)} className='form-control'
                                            options={tipos.map((item) => {
                                                return {
                                                    label: item.value,
                                                    value: item.key
                                                }
                                            }) as any[]} />
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <Select placeholder={t("Selecione uma conta")} isDisabled={carregando} className='form-control' value={conta} onChange={(e) => setConta(e || null)} options={planoContas.map((item) => {
                                            return {
                                                label: `${item.codigo} - ${item.descricao}`,
                                                value: item.codigo
                                            }
                                        }) as any[]} />
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <button className='btn btn-success mt-2' onClick={onSubmit} disabled={carregando}>{t("Salvar")}</button>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{t("Descrição")}</th>
                                        <th scope="col">{t("Conta")}</th>
                                        <th scope='col'></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mapeamentos.map((item: any) => (
                                        <tr key={uniqueId()}>
                                            <th scope="row">{item.descricao}</th>
                                            <th scope="row">{item.conta}</th>
                                            <th scope='row'><i onClick={() => onRemove(item.id)} className="fas fa-trash-alt fs-1"></i></th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ModalMapeamento;